import {PopupDropdown} from '@wandb/weave/common/components/PopupDropdown';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {LinkNoCrawl} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Header} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const TeamSidebarHeader = styled(Header)`
  margin: 0 0 4px;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;

  display: flex;
  align-items: center;
`;

const linkHoverStyle = (initialLinkColor: string) => `
  a {
   color: ${initialLinkColor};
    &:hover {
      color: ${globals.TEAL_600};
    }
  }
`;

export const CenteredIconText = styled.span`
  display: flex;
  align-items: center;
`;

export const TeamSidebarLink = styled(LinkNoCrawl)`
  color: ${globals.gray500};
  &:hover {
    color: ${globals.TEAL_600};
  }
`;

export const TeamSidebarDisabledLinkText = styled.div`
  color: ${globals.gray500};
`;

export const TeamSidebarApplicationsLink = styled.div`
  margin-top: ${globals.spu};
  font-size: 16px;
  ${linkHoverStyle(globals.gray500)}
`;

export const EnterpriseDashboardLink = styled.div`
  margin-top: ${globals.spu};
  ${linkHoverStyle(globals.gray500)}
`;

export const Section = styled.div`
  margin-top: calc(${globals.spu} * 5);
`;

// Weekly active users section
export const ActiveUsersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 13px;
  color: ${globals.gray700};
`;

export const ActiveUserRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;

  ${linkHoverStyle(globals.gray700)}
`;

export const ActiveUserName = styled.div`
  &&& {
    display: flex;
    align-items: center;
    margin: 8px 0 0;
    height: 24px;
  }
`;

export const ActiveUserRunCount = styled.span`
  float: right;
`;

// Team members sections
export const TeamMembersHeader = styled.div`
  text-transform: uppercase;
  font-size: 13px;
  color: ${globals.gray700};
  ${linkHoverStyle(globals.gray700)}
`;

export const TeamMembersHeaderText = styled.p`
  color: ${globals.gray700};
  line-height: unset;
  margin: unset;
`;

export const TeamMemberRow = styled.div`
  ${linkHoverStyle(globals.gray700)}
  &&& {
    display: flex;
    align-items: center;
    margin: 8px 0 0;
    height: 24px;
  }
`;

const avatarStyles = `
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-right: 6px;
  border-radius: 50%;
`;

export const TeamMemberAvatar = styled.img`
  ${avatarStyles}
`;

export const FallbackAvatar = styled.div<{$topOffset?: number}>`
  ${avatarStyles}
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: ${globals.white};
  background-color: ${globals.green};
  position: relative;
  top: ${({$topOffset = 0}) => $topOffset}px;
`;

export const TeamMemberName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TeamMemberTag = styled.div`
  margin-left: 6px;
  border-radius: 4px;
  font-size: 13px;
  padding: 0 6px;
  background-color: ${globals.gray300};
`;

export const TeamMembersViewAllLink = styled.div`
  margin-top: ${globals.spu};
  ${linkHoverStyle(globals.gray500)}
`;

// Org subscriptions link
export const SubscriptionsText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NoMembersMessage = styled.p`
  color: ${globals.MOON_600};
  font-size: 14px;
  margin-top: 6px;
`;

export const JoinTeamDropdown = styled(PopupDropdown)`
  &&&& {
    min-width: auto;
  }
  padding: 6px 12px;
  border-radius: 3px;
  height: 36px;
  border: 1px solid ${globals.MOON_200};

  .ui.dropdown .menu {
    width: 120px;
    top: -16px;
  }
`;

export const JoinTeamDropdownMenu = styled.div`
  border: 1px solid ${globals.MOON_200};
  padding: 6px 12px;
  border-radius: 3px;
  width: 120px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
